import WAYPOINTS from './waypoint-database.json'

function getDistance(a, previousWaypoint) {
  return Math.sqrt(Math.pow(a.lat - previousWaypoint.lat, 2) + Math.pow(a.long - previousWaypoint.long, 2));
}

export function lookup(searchValue, previousWaypoint = null) {
  if (!searchValue) {
    return null;
  }
  const predictions = WAYPOINTS.waypoints.filter(waypoint => waypoint.code.startsWith(searchValue.toUpperCase()));

  if (previousWaypoint) {
    // sort by distance to previous waypoint
    predictions.sort((a, b) => {
      return getDistance(a, previousWaypoint) - getDistance(b, previousWaypoint);
    });
  }

  if (predictions && predictions.length > 0) {
    return predictions[0];
  } else {
    return null;
  }
}

export function fetch(code, previousWaypoint = null) {
  const searchResults = WAYPOINTS.waypoints.filter(waypoint => waypoint.code === code);
  if (searchResults && searchResults.length > 0) {
    if (previousWaypoint) {
      searchResults.sort((a, b) => {
        return getDistance(a, previousWaypoint) - getDistance(b, previousWaypoint);
      });
    }
    return searchResults[0];
  } else {
    return null;
  }
}